import { render, staticRenderFns } from "./ModalChart.vue?vue&type=template&id=1008158b&scoped=true&"
import script from "./ModalChart.vue?vue&type=script&lang=js&"
export * from "./ModalChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1008158b",
  null
  
)

export default component.exports